module.exports = __webpack_public_path__ + "static/media/icons-ic-cold-call.894850f8.svg";